import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { AppConfig, APP_CONFIG } from 'src/app.config';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  public API_URL: string;

  constructor(
    @Inject(APP_CONFIG) appConfig: AppConfig,
    private http: HttpClient
  ) {
    this.API_URL = appConfig.urlApi;
  }

  connection(login: any, password: any): Observable<any> {
    const url = this.API_URL + '/get-login';
    return this.http.post<any>(url, {
      userName: login,
      password: password,
    });
  }
}
